// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__3NR-c","closeBtn":"Modal_closeBtn__17Qg2","content":"Modal_content__3a0fl","img":"Modal_img__2NhDd"};